import React, { useContext, useEffect } from "react";
import { AuthContext } from "src/contexts/AuthContext";
import { Button, HollowButton, MainContainer } from "../../components";
import config from "../../config";
import { ThemeContext } from "../../contexts/ThemeContext";
import { sendEvent } from "../../hooks/analytics";
import { useQueryParams } from "../../hooks/queryParams";
import { AlertIcon } from "../Error/Icons";
import {
  Container,
  ContainerButton,
  ContainerDescription,
  Description,
  ErrorContent,
  ErrorId,
  FamilyTitle,
  FlexContent,
  MessageDescription,
  TextLabel,
} from "../styles";

const Family = () => {
  const { authenticate } = useContext(AuthContext);
  useEffect(() => {
    authenticate();
  }, []);

  const { setHeaderReturn, setHeaderUser } = useContext(ThemeContext);
  setHeaderReturn(true);
  setHeaderUser(true);

  const redirectUrl =
    localStorage.getItem("callbackUrl") || "https://globo.com";
  const myFamilyRedirectUrl = config.MINHA_FAMILIA_URL + "/?mode=dark";
  const globoId = localStorage.getItem("globoId") || "";
  const providerName = localStorage.getItem("providerName") || "";
  const queryParams = useQueryParams();
  const errorId = queryParams.get("error_id") || "";
  const errorIdText = errorId ? `CÓD. ${errorId}` : "";

  useEffect(() => {
    sendEvent(
      "alf_page_view",
      {
        user_code_provider_hit: "cadun",
        page_name_custom: "erro_gerenciar_familia",
        provider_name: providerName,
      },
      { user_code: globoId, user_code_provider: "cadun" }
    );
  }, [globoId, providerName]);

  const redirectTo = () => {
    sendEvent(
      "component_click",
      {
        component_name: "voltar_para_produto",
        component_type: "button",
        component_item_link_redirect: redirectUrl,
        page_name_custom: "erro_gerenciar_familia",
        provider_name: providerName,
      },
      { user_code: globoId, user_code_provider: "cadun" }
    );

    window.location.href = redirectUrl;
  };

  const redirectToMyFamily = () => {
    sendEvent(
      "component_click",
      {
        component_name: "gerenciar_minha_familia",
        component_type: "button",
        component_item_link_redirect: myFamilyRedirectUrl,
        page_name_custom: "erro_gerenciar_familia",
        provider_name: providerName,
      },
      { user_code: globoId, user_code_provider: "cadun" }
    );

    window.location.href = myFamilyRedirectUrl;
  };

  return (
    <MainContainer>
      <Container>
        <FlexContent>
          <AlertIcon />
          <ErrorContent>
            {errorId && <ErrorId>{errorIdText}</ErrorId>}
            <FamilyTitle>
              Você já tem essa assinatura através do Minha Família
            </FamilyTitle>
          </ErrorContent>
        </FlexContent>

        <MessageDescription>
          <TextLabel>
            Para acessar o conteúdo, você precisa sair do Minha Família.
          </TextLabel>
          <TextLabel>
            Ao sair, você abrirá mão dos benefícios da conta titular.
          </TextLabel>
        </MessageDescription>
        <ContainerDescription>
          <Description>Já saiu da sua Conta Família?</Description>
          <Description>
            Agora atualize a página para continuar o login por operadora.
          </Description>
        </ContainerDescription>
      </Container>

      <ContainerButton>
        <Button onClick={redirectTo}>Voltar para o produto</Button>
        <HollowButton onClick={redirectToMyFamily}>
          Gerenciar Minha Família
        </HollowButton>
      </ContainerButton>
    </MainContainer>
  );
};

export default Family;
